import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  Typography,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ISubTopicFAQ } from '../../../../store/SubTopicSlice';

const accordionStyles: AccordionProps['sx'] = {
  border: '1px solid #ededed',
  boxShadow: 'none',
  borderRadius: '7px',
  marginBottom: '10px',
  '&:before': {
    display: 'none',
  },
};

export interface IFAQSection {
  faqList: ISubTopicFAQ[];
}

const FAQSection: React.FC<IFAQSection> = ({ faqList }) => {
  return (
    <div style={{ margin: '30px 40px' }}>
      <Typography variant="h5" fontWeight={600} style={{ margin: '10px' }}>
        FAQs
      </Typography>
      {faqList.map((faqItem) => (
        <Accordion key={faqItem._id} sx={accordionStyles}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="subtitle2" fontWeight={600}>
              {faqItem.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="subtitle2">{faqItem.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default FAQSection;
